import { LegalEntityStatusEffects } from './legal-entity-status.effect';
import { LoginEffects } from './login.effects';
import { LoyaltyProgramEffects } from './loyalty-program.effects';

export const effects: any[] = [LoginEffects, LegalEntityStatusEffects, LoyaltyProgramEffects];
